export default __webpack_public_path__ + "static/media/cd-icons-cart-close.23391035.svg";